import { track, analyticsKeys } from '@mobi/account/Utils'

export type BetLimitEvent = {
  interaction_type: 'Remove Bet Limit' | 'Edit Bet Limit' | 'Need Assistance'
  limitAmount: string | undefined
  location: 'Bet Limits' | undefined
  depositFrequency: undefined
}

const defaultBetLimitValues: Omit<BetLimitEvent, 'interaction_type'> = {
  limitAmount: undefined,
  location: undefined,
  depositFrequency: undefined,
}

export const betLimitTracker = (event: BetLimitEvent) =>
  track(analyticsKeys.accountManagement, event)

export const trackRemoveBetLimit = () =>
  betLimitTracker({
    interaction_type: 'Remove Bet Limit',
    ...defaultBetLimitValues,
  })

export const trackEditBetLimit = (limitAmount: string) =>
  betLimitTracker({
    interaction_type: 'Edit Bet Limit',
    ...defaultBetLimitValues,
    limitAmount,
  })

export const trackNeedAssistance = () =>
  betLimitTracker({
    interaction_type: 'Need Assistance',
    ...defaultBetLimitValues,
    location: 'Bet Limits',
  })
